export default __webpack_public_path__ + "static/media/rn.5166d1ab.png";